import { FunctionComponent } from 'react';

import ArticlesSearch from 'components/modules/public/layout/forms/SearchEmployeeArticlesForm';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageArticlesEmployeeListSectionForm: FunctionComponent<Props> = ({ translations: { formProps }, articleCategories }) => {
    return (
        <StyledComponent
            className="public-page-articles-employee-list-section-form"
        >
            <ArticlesSearch
                {...formProps}
                categories={articleCategories}
            />
        </StyledComponent>
    );
};

export default PublicPageArticlesEmployeeListSectionForm;